import { $, T } from '../../common/drupal/drupal';

class Lists {

    init() {
        $('select[multiple="multiple"]').select2();

        Array.from($('.NodeList-form label')).forEach((el, i) => {
            let $select = $(el).siblings('select')[0];
            $(el).siblings('span.select2').css('width', '100%');
            el.setAttribute('role', 'button');

            el.addEventListener('click', function () {
                $(this).toggleClass('opened');
                $(this).siblings().toggleClass('show');
            });

            if ($select.options.selectedIndex !== -1) {
                $(el).addClass('opened');
                $(el).siblings().addClass('show');
            }
        });
    }

    /**
     * Attach.
     * @param context
     */
    attach(context) {
        if (T.contextIsRoot(context)) {
            this.init();
        }
    }

}

export let lists = new Lists();